import { apiFetch } from '../utils/api';

export interface ProductCategory {
  id: string;
  erpId: number;
  name: string;
  createdAt: string;
  updatedAt: string;
}

export interface PaginatedCategoriesResponse {
  data: ProductCategory[];
  total: number;
  page: number;
  limit: number;
  totalPages: number;
}

export interface FetchCategoriesParams {
  page?: number;
  limit?: number;
  search?: string;
}

export const fetchProductCategories = (
  params: FetchCategoriesParams = {},
): Promise<PaginatedCategoriesResponse> => {
  const searchParams = new URLSearchParams();

  if (params.page) {
    searchParams.set('page', String(params.page));
  }

  if (params.limit) {
    searchParams.set('limit', String(params.limit));
  }

  if (params.search) {
    searchParams.set('search', params.search);
  }

  const query = searchParams.toString();
  const path = `/product/categories${query ? `?${query}` : ''}`;

  return apiFetch<PaginatedCategoriesResponse>(path);
};
